import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, DialogContainer, TextField } from 'react-md';

const AddNoteBlock = ({ id, strings, createNote }) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState(undefined);

  const show = () => {
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };

  const handleConfirm = () => {
    // console.log('handleConfirm', id, message);
    createNote({ id, message });
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleChange = name => value => {
    if (name === 'message') setMessage(value);
  };

  const actions = [];
  actions.push({
    secondary: true,
    children: strings['contract.notes.actions.cancel.btn.label'] || 'Cancel',
    onClick: handleCancel
  });
  actions.push({
    primary: true,
    children: strings['contract.notes.actions.confirm.btn.label'] || 'Confirm',
    onClick: handleConfirm
  });
  // actions.push(
  //   <Button flat primary onClick={hide}>
  //     Confirm
  //   </Button>
  // );

  return (
    <div className="blocks-actions">
      <Button
        key={id}
        floating
        primary
        swapTheming
        tooltipLabel={strings['contract.notes.actions.newNote.btn.label'] || 'Ajouter une Note'}
        tooltipPosition="left"
        onClick={show}
      >
        add
      </Button>
      <DialogContainer
        className="addnote-action-dialog"
        id="addnote-action-dialog"
        visible={visible}
        onHide={hide}
        actions={actions}
        title={strings['contract.notes.actions.newNote.btn.label'] || 'Add New Note'}
      >
        <TextField
          id="addnote-action-dialog-field"
          label={strings['contract.notes.actions.message.btn.label'] || 'Message'}
          placeholder={strings['contract.notes.actions.placeholder.btn.label'] || 'Content...'}
          rows={1}
          onChange={handleChange('message')}
        />
      </DialogContainer>
    </div>
  );
};

AddNoteBlock.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strings: PropTypes.objectOf(PropTypes.string).isRequired,
  createNote: PropTypes.func.isRequired
};

export default AddNoteBlock;
